import {ChangeDetectionStrategy, Component, Inject} from "@angular/core";
import {MAT_DIALOG_DATA, MatDialog, MatDialogModule, MatDialogRef} from "@angular/material/dialog";
import {EnkelGruppeModell, GruppeMedlemListeModell} from "felles-ng2/tjenester/ressurser/generertNg2HttpKlient";
import {MedlemInvitasjonRedigerKomponent} from "../../komponenter/medlem-invitasjon-rediger/medlem-invitasjon-rediger";

export type MedlemInvitasjonRedigerDialogRespons = boolean;

export interface DialogParametre {
    invitasjon: GruppeMedlemListeModell;
    gruppe: EnkelGruppeModell;
}

@Component({
    selector: 'medlem-invitasjon-rediger-dialog',
    templateUrl: './medlem-invitasjon-rediger-dialog.html',
    styleUrl: './medlem-invitasjon-rediger-dialog.scss',
    host: { 'class': 'e2e-medlem-invitasjon-rediger-dialog' },
    imports: [
        MatDialogModule,
        MedlemInvitasjonRedigerKomponent
    ],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class MedlemInvitasjonRedigerDialogKomponent {

    static vis(dialog: MatDialog, invitasjon: GruppeMedlemListeModell, gruppe: EnkelGruppeModell): MatDialogRef<MedlemInvitasjonRedigerDialogKomponent, MedlemInvitasjonRedigerDialogRespons> {
        return dialog.open(MedlemInvitasjonRedigerDialogKomponent, {
            data: {invitasjon, gruppe} as DialogParametre,
            disableClose: true,
            ariaLabelledBy: 'medlem-invitasjon-rediger-dialog-tittel',
            maxWidth: '900px',
            width: '100%'
        });
    }

    invitasjon: GruppeMedlemListeModell;
    gruppe: EnkelGruppeModell;

    constructor(@Inject(MAT_DIALOG_DATA) parametre: DialogParametre,
                public dialogRef: MatDialogRef<MedlemInvitasjonRedigerDialogKomponent, MedlemInvitasjonRedigerDialogRespons>) {
        this.invitasjon = parametre.invitasjon;
        this.gruppe = parametre.gruppe;
    }

    vedLagret() {
        this.dialogRef.close(true);
    }

    avbryt() {
        this.dialogRef.close(false);
    }
}
